<template>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-card-title>Add a sentence to {{ hszn.huis_code }}</v-card-title>
            <v-card-text>
                <div class="scrollable">
                    <v-form ref="addHszn" v-model="addHsznValid" >
                        <ul class="ul_style">
                            <li>
                                <v-container class="py-0">
                                    <v-card class="mb-2" v-for="(groep, i) in hszn.groepen" :key="i">
                                        <v-card-title class="pa-2 pl-4 pb-0"><h5>{{ groep.groep }}</h5></v-card-title>
                                        <v-card-text>
                                            <div v-for="(zinnRecord, j) in groep.zinnen" :key="j">
                                                <v-checkbox v-model="zinnRecord.zinn_selected" :label="`${zinnRecord.zinntaal_oms} ${getZinnNr(zinnRecord)}`"></v-checkbox>

                                                <v-text-field v-if="zinnRecord.var1" v-model="zinnRecord.val1" label="Text 1" :rules="zinn_valRules" :hint="zinnRecord.hint1"></v-text-field>        
                                                <v-select v-if="zinnRecord.leeftijd1" v-model="zinnRecord.val1" :items="leeftijdKeuzes" item-value="leeftijd_code" item-text="leeftijd_oms" label="Age 1" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.mnd1" v-model="zinnRecord.val1" :items="maandKeuzes" item-value="maand_code" item-text="maand_oms" label="Month 1" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.dag1" v-model="zinnRecord.val1" :items="dagKeuzes" item-value="dag_code" item-text="dag_oms" label="Weekday 1" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.year1" v-model="zinnRecord.val1" :items="jaarKeuzes" item-value="jaar_code" item-text="jaar_oms" label="Year 1" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.time1" v-model="zinnRecord.val1" :items="tijdKeuzes" item-value="tijd_code" item-text="tijd_oms" label="Time 1" dense class="selection-width"></v-select>

                                                <v-text-field v-if="zinnRecord.var2" v-model="zinnRecord.val2" label="Text 2" :rules="zinn_valRules" :hint="zinnRecord.hint2"></v-text-field>
                                                <v-select v-if="zinnRecord.mnd2" v-model="zinnRecord.val2" :items="maandKeuzes" item-value="maand_code" item-text="maand_oms" label="Month 2" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.dag2" v-model="zinnRecord.val2" :items="dagKeuzes" item-value="dag_code" item-text="dag_oms" label="Weekday 2" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.year2" v-model="zinnRecord.val2" :items="jaarKeuzes" item-value="jaar_code" item-text="jaar_oms" label="Year 2" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.time2" v-model="zinnRecord.val2" :items="tijdKeuzes" item-value="tijd_code" item-text="tijd_oms" label="Time 2" dense class="selection-width"></v-select>

                                                <v-text-field v-if="zinnRecord.var3" v-model="zinnRecord.val3" label="Text 3" :rules="zinn_valRules" :hint="zinnRecord.hint3"></v-text-field>
                                                <v-select v-if="zinnRecord.mnd3" v-model="zinnRecord.val3" :items="maandKeuzes" item-value="maand_code" item-text="maand_oms" label="Month 3" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.dag3" v-model="zinnRecord.val3" :items="dagKeuzes" item-value="dag_code" item-text="dag_oms" label="Weekday 3" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.year3" v-model="zinnRecord.val3" :items="jaarKeuzes" item-value="jaar_code" item-text="jaar_oms" label="Year 3" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.time3" v-model="zinnRecord.val3" :items="tijdKeuzes" item-value="tijd_code" item-text="tijd_oms" label="Time 3" dense class="selection-width"></v-select>

                                                <v-text-field v-if="zinnRecord.var4" v-model="zinnRecord.val4" label="Text 4" :rules="zinn_valRules" :hint="zinnRecord.hint4"></v-text-field>
                                                <v-select v-if="zinnRecord.mnd4" v-model="zinnRecord.val4" :items="maandKeuzes" item-value="maand_code" item-text="maand_oms" label="Month 4" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.dag4" v-model="zinnRecord.val4" :items="dagKeuzes" item-value="dag_code" item-text="dag_oms" label="Weekday 4" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.year4" v-model="zinnRecord.val4" :items="jaarKeuzes" item-value="jaar_code" item-text="jaar_oms" label="Year 4" dense class="selection-width"></v-select>
                                                <v-select v-if="zinnRecord.time4" v-model="zinnRecord.val4" :items="tijdKeuzes" item-value="tijd_code" item-text="tijd_oms" label="Time 4" dense class="selection-width"></v-select>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-container>
                            </li>
                        </ul>
                    </v-form>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHszn">Save</v-btn>
                <v-btn color="primary" small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // import {bus} from "../../../main";

    export default {
        data() { 
            return {
                dialog: false,
                addHsznValid: false,
                huis_encrid: null,
                maandKeuzes: [],
                dagKeuzes: [],
                jaarKeuzes: [],
                tijdKeuzes: [],
                leeftijdKeuzes: [],
                hszn: {},
                zinnen: [],
                zinn_nrRules: [
                    v => !!v || "A Sentence is required"
                ],
                zinn_valRules: [
                    v => !!v || "A value is required"
                ] 
            }
        },
        methods: {
           open(huis_encrid) {
                // var deze = this;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hszn/getHuisToAddHszn4.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHszn",
                    },
                    getHuisToAddHszn: {
                        huis_encrid: huis_encrid,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                } else {
                    this.hszn = res.data.getHuisToAddHszn;
                    this.maandKeuzes = res.data.getHuisToAddHszn.maandKeuzes;
                    this.dagKeuzes = res.data.getHuisToAddHszn.dagKeuzes;
                    this.jaarKeuzes = res.data.getHuisToAddHszn.jaarKeuzes;
                    this.tijdKeuzes = res.data.getHuisToAddHszn.tijdKeuzes;
                    this.leeftijdKeuzes = res.data.getHuisToAddHszn.leeftijdKeuzes;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getZinnNr(v){
            return this.hszn.showNumbers?`(${v.zinn_nr})`:''
        },
        addHszn() { 
            console.log('hszn', this.hszn)
            this.zinnen = [];
            for (let i = 0; i < this.hszn.groepen.length; i++) {
                for (let j = 0; j < this.hszn.groepen[i].zinnen.length; j++) {
                    this.zinnen.push(this.hszn.groepen[i].zinnen[j])
                }            
            }
            console.log('zinnen', this.zinnen)
            this.$axios.post("ares/json/ares/huis/hszn/addHszn2.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "addHszn"
                },
                addHszn: {
                    huis_encrid: this.hszn.huis_encrid,
                    zinnen: this.zinnen,
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else { 
                    // if (res.data.addHszn.color == "success")
                    //     //this.$router.reload('/huis/onHuis/' + res.data.addHszn.huis_encrid);
                    //     bus.$emit("closeDialog", "reload");
                    // else {               
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHszn.text,
                            color: res.data.addHszn.color
                        }); 
                     this.$emit('updateData');
                    //}  
                    this.dialog = false;
                }
            })
        }
    }
}
</script>

<style scoped>
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 700px;
        overflow-y: auto;
    }
    .selection-width  {
        width: 140px;
    }
</style>
